/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2022 Deere & Company

import './dealer-mapping.scss';
import NumberOfRecordsFound from '../../../../sharedmodules/components/number-of-records-found';
import PinTransferList from './pin-transfer-list';
import PropTypes from 'prop-types';
import React from 'react';

const DealerMapping = (props) => (
    props.userDealerMappedData.length ? (
        <div>
            {props.userDealerMappedData[0].currentDealer.account !== '' ?
                <NumberOfRecordsFound count={props.userDealerMappedData.length} />
                : null}
            <section className="transfer-approvals ">
                <PinTransferList
                    actions={props.actions}
                    auth={props.auth}
                    transfers={props.userDealerMappedData}
                />
            </section>
        </div>
    ) : null
);

DealerMapping.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object.isRequired,
    userDealerMappedData: PropTypes.array,
    updateTransferComment: PropTypes.func,
};

export default DealerMapping;
